import { IBgColor } from "@/types/types";

export const CARDS_DATA = [
	{
		name: "CASUAL\nGAMES",
		titles: [
			{ title: "POWERSHARK PRACTICE", bgColor: "greenCard1" as IBgColor },
		],
		button: "",
		bg: "card1",
		bgImage: "/images/card1.png",
	},
	{
		name: "DAILY\nTOURNAMENTS",
		titles: [
			{ title: "36 DAILY EVENTS", bgColor: "orangeCard1" as IBgColor },
			{ title: "FREE OR PAID ENTRY", bgColor: "orangeCard2" as IBgColor },
			{ title: "ANY GAME, ANY TIME", bgColor: "orangeCard3" as IBgColor },
		],
		button: "WBT POINTS",
		bg: "card2",
		bgImage: "/images/card2.png",
		bgCenter: true,
	},
	{
		name: "SUPER\nSATURDAY",
		titles: [{ title: "WEEKLY EVENT", bgColor: "purpleCard1" as IBgColor }],
		button: "WBT POINTS & CASH PRIZES",
		bg: "card3",
		bgImage: "/images/card3.png",
	},
	{
		name: "WBT RACE\nFINAL",
		titles: [{ title: "COMING SOON", bgColor: "orangeCard2" as IBgColor }],
		button: "CASH PRIZES",
		bg: "card4",
		bgImage: "/images/card2.png",
		bgCenter: true,
	},
];

export const PHONE_TOOLTIPS = [
	{
		number: "6",
		text: "New & improved features that make playing bridge online even more enjoyable. For example, Max Score is a brand new feature, and Double Dummy is improved in WBT Bridge.",
		white: false,
	},
	{
		number: "2",
		text: "Time world champion bridge algorithm, SharkBridge, was overhauled by WBT to create PowerShark. The NEW PowerShark tests in the 1st percentile of all bridge players.",
		white: true,
	},
	{
		number: "36",
		text: "Conventions that PowerShark plays by. As a result, PowerShark acts logically, like a real bridge partner, adapting to your choices.",
		white: false,
	},
];

export const PRIZES = [
	{
		img: "coins",
		title: "Raise the Prize Pool",
		text: "Increased prizes on Super Saturday events",
	},
	{
		img: "people",
		title: "Casual or Competitive",
		text: "Play casual games or climb the leaderboards and win prizes",
		white: true,
	},
	{
		img: "shark",
		title: "Practice with PowerShark",
		text: "Live tips for optimal experience, AI response to your style of play, and anti-cheat systems",
	},
];

export const FAQS = [
	{
		title: "How can I improve my performance playing with PowerShark?",
		text: `PowerShark Guide: [https://wbtbridge.com/powershark-information](https://wbtbridge.com/powershark-information).\n\n PowerShark is advanced compared to other robot software. It is designed to feel like a human bridge partner. It will consider your choices, and even make human plays like bluffing. Improve your PowerShark game, and you will also improve your bridge game generally!`,
	},
	{
		title: "How do I enter the WBT Summer Race?",
		text: "We are excited to introduce the WBT Summer Race to the bridge community!\n\n The leaders of this online tournament will qualify for a closed, in-person event: The WBT Summer Race Final!\n\n The online WBT Summer Race begins June 1st, 2024 and ends August 31st, 2024.\n\n The in-person Final will take place on September 8th, 2024. It is closed to 36 qualified players.\n\n You do not need to register. You are entered into the WBT Summer Race when you earn WBT Points. Earn WBT Points by completing any daily tournament (Speedball, Standard, or Booster) or any weekly tournament (Super Saturday/Sunday). These events stand out because of their [insert colour] colour.\n\n Accumulate WBT Points to raise your rank in the leaderboards. Top players in the leaderboards qualify for closed events and increased prizes!\n\n There is no registration fee. The only cost is purchasing WBT Coins, which are used to pay for a tournament’s entry fee.\n\n Conditions of Contest: [hyperlink]",
	},
	{
		title: "Who is WBT?",
		text: "In addition to developing the WBT Bridge app, World Bridge Tour organises high-end, competitive bridge tournaments across Europe and beyond.\n\n WBT Points, Tokens, and Coins earned in the WBT Bridge app can also be used for WBT’s face-to-face event offerings.\n\n About WBT: [https://www.worldbridgetour.org/about](https://www.worldbridgetour.org/about)",
	},
	{
		title: "My question isn’t covered here. Where can I get further support?",
		text: "Find more FAQ’s here: [hyperlink]\n\n And please reach out to us directly at [hi@wbtbridge.com](hi@wbtbridge.com) .",
	},
];
